import request from '../../utils/request'
import Axios from 'axios'
import { UrlSearch } from '../../utils/UrlSearch'
const shopTitle = UrlSearch().shop
let shopName
if (shopTitle) {
  let index = shopTitle.indexOf('.')
  if (index > 0) {
    shopName = shopTitle.substring(0, index)
  } else {
    shopName = shopTitle
  }
}
export function getChartFree (params) { // 余额-运费总计 get-chart-fee
  params.shopName = shopName
  return request({
    url: 'get-chart-fee',
    method: 'get',
    params: params
  })
}
export function getPlanUsage (params) { // 仓储服务数据 get-plan-usage
  params.shopName = shopName
  return request({
    url: 'get-plan-usage',
    method: 'get',
    params: params
  })
}

export function kindOfSku (params) { // 产品概况数据 kind-of-sku
  params.shopName = shopName
  return request({
    url: 'kind-of-sku',
    method: 'get',
    params: params
  })
}
export function kindOfOrder (params) { // 订单概况数据 kind-of-order
  params.shopName = shopName
  return request({
    url: 'kind-of-order',
    method: 'get',
    params: params
  })
}
export function getMaster (params) { // 客户客服信息 get-manager
  params.shopName = shopName
  return request({
    url: 'get-manager',
    method: 'post',
    params: params
  })
}
export function sendOrderTime (params) { // 下次交寄订单时间-当前店铺状态-店铺状态主键
  params.shopName = shopName
  return request({
    url: 'get-last-import-time',
    method: 'get',
    params: params
  })
}
export function changeStatus (params) { // 暂停/启动服务
  params.shopName = shopName
  return request({
    url: 'update-import-status',
    method: 'get',
    params: params
  })
}
export function getNotice () {
  return Axios.get('https://blog.sendfromchina.com/blog/wp-json/wp/v2/posts?categories=11')
}

//  获取用户当前状态
export function getShopifyStep (params) { // 暂停/启动服务
  params.shopName = shopName
  return request({
    url: 'get-shopify-step',
    method: 'POST',
    params: params
  })
}

// 设置当前用户状态
export function updateShopifyStep (params) { // 暂停/启动服务
  params.shopName = shopName
  return request({
    url: 'update-shopify-step',
    method: 'POST',
    params: params
  })
}

// 用户认证状态
export function isVerify () {
  return request({
    url: 'is-verify',
    method: 'POST'
  })
}



// WEBPACK FOOTER //
// ./src/components/views/api/home.js